import {
  Children,
  cloneElement,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from "react";

import { cn } from "@/utils/utils";

/** Minimal `asChild` support — merges props onto a single child element. */
export function Slot({
  children,
  className,
  ...props
}: { children?: ReactNode; className?: string } & Record<string, unknown>) {
  if (!isValidElement(children)) return null;

  const child = children as ReactElement<Record<string, unknown>>;
  return cloneElement(child, {
    ...props,
    ...child.props,
    className: cn(className, child.props["className"] as string | undefined),
  });
}

export const countChildren = (children: ReactNode) => Children.count(children);
